import React, { useState, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { Button, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

import { config } from '../config';
import { setAlert } from '../store/actions/alertActions';

export const ShareItineraryButton = ({ 
  isMobile, 
  convertProfiltForApi, 
  status, 
  allResults,
  multimodalActivated = true
}) => {

  const {t} = useTranslation();
  const styles = {
    buttonSetting: {
      minHeight: 0,
      minWidth: 0,
      padding: 0.5,
      paddingLeft: 1,
      paddingRight: 1,
      borderRadius: '0.5em',
      fontSize: isMobile ? '1.7em' : '0.875em',
      backgroundColor: 'white',
      fontStyle: 'normal',
      textTransform: 'none',
      marginLeft: '1em',
      '&:hover': {
        backgroundColor: '#767676',
        color: 'white'
      }
    }
  };

  const origin = [...useSelector(state => state.directions.origin.marker)];
  const destination = [...useSelector(state => state.directions.destination.marker)];

  const profil = useSelector(state => state.profils.profil);
  const condition = useSelector(state => state.profils.condition);
  const multimodal = useSelector(state => state.profils.multimodal);
  const selectedDate = useSelector(state => state.profils.time);
  const apiProfile = convertProfiltForApi(profil);

  const selectedPath = useSelector(state => state.directions.selectedPath);

  const [urlTocopy, setUrlToCopy] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    setUrlToCopy(`${config.url.PUBLIC_URL}?origin=${origin[0]},${origin[1]}&destination=${destination[0]},${destination[1]}&profil=${profil}&condition=${condition}&multimodal=${multimodal}&selectedPath=${selectedPath}${multimodalActivated && multimodal ? `&time=${selectedDate.format('YYYY-MM-DDTHH:mm')}` : ''}`);
  }, [origin, destination, profil, condition, multimodal, apiProfile, selectedPath, selectedDate]);

  const handleCopy = () => {
    navigator.clipboard.writeText(encodeURI(urlTocopy));
    dispatch(setAlert(t('share-itinerary.message'), 'success', t('share-itinerary.message-title'), 'status'));
  };

  return (
    <Box style={{ display: 'flex'}}>
      {status === 'success' && allResults.length > 0 && 
      <Button 
        endIcon={<FontAwesomeIcon icon={faCopy} />} 
        sx={styles.buttonSetting} 
        size='small' 
        variant='outlined'
        onClick={handleCopy}>
        {t('share-itinerary.button')}
      </Button>}
    </Box>
  );
};